import React from "react";
import { convert } from "html-to-text";
import { VIEW_ONLY_EMPTY_MESSAGE } from "../../hooks/useAdminPermissions";

const EMPTY_HTML_SNIPPETS = new Set([
  "<p><br></p>",
  "<p></p>",
  "<br>",
  "<br/>",
  "<br />",
]);

const decodeHtmlEntities = (text) => {
  if (typeof document === "undefined") {
    return text
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  }

  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

export const getDraggerPlainText = (html) => {
  if (html == null || typeof html !== "string") {
    return "";
  }

  const plain = convert(html, { wordwrap: false }).trim();
  if (plain) {
    return decodeHtmlEntities(plain);
  }

  return decodeHtmlEntities(
    html
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/\n{3,}/g, "\n\n")
      .trim(),
  );
};

export const hasDraggerHtmlContent = (html) => {
  if (html == null || typeof html !== "string") {
    return false;
  }

  const trimmed = html.trim();
  if (!trimmed || EMPTY_HTML_SNIPPETS.has(trimmed.toLowerCase())) {
    return false;
  }

  return getDraggerPlainText(html).length > 0;
};

export const hasUnsavedDraggerHtml = (currentText, savedHtml) => {
  const saved = savedHtml ?? "";
  const current = currentText ?? "";

  if (current === saved) {
    return false;
  }

  return convert(current).trim() !== "";
};

export const getDraggerViewHtml = (html) => {
  if (html == null || typeof html !== "string") {
    return "";
  }

  const trimmed = html.trim();
  if (!trimmed) {
    return "";
  }

  if (/&lt;|&gt;|&amp;(?:lt|gt|quot|#39);/i.test(trimmed)) {
    return decodeHtmlEntities(trimmed);
  }

  return trimmed;
};

export const ViewOnlyHtmlContent = ({ html }) => (
  <div
    className="editorContent product-view-only-html"
    dangerouslySetInnerHTML={{ __html: getDraggerViewHtml(html) }}
  />
);

const ProductPermissionDenied = ({ message = VIEW_ONLY_EMPTY_MESSAGE, isHtml = false }) => (
  <div
    className={`product-permission-denied ${
      isHtml ? "product-permission-denied--html" : ""
    }`}
  >
    {message}
  </div>
);

export default ProductPermissionDenied;
